import React, {useEffect, lazy, Suspense} from "react";
import HorizontalNav from "./containers/Navigation/Horizontal";
import Banner from "./containers/Banner";
import BusinessModule from "./containers/BusinessModule";
import Footer from "./containers/Footer";
import './App.css';
// const LazyTestimonials = lazy(() => import("./containers/Testimonial"));
const LazyChooseUs = lazy(() => import("./containers/ChooseUs"));
const LazyVerticals = lazy(() => import("./containers/Verticals"));
const LazyAboutUs = lazy(() => import("./containers/About"));
const LazyServiceModule = lazy(() => import("./containers/Services"));
const LazyGlobalReach = lazy(() => import("./containers/GlobalReach"));
const LazyLhYug = lazy(() => import("./containers/LhyugApp"));


function App() {

    useEffect(() => {
        const gaId = process.env.REACT_APP_GA_ID;

        if (!gaId) {
            console.error('Google Analytics ID is not defined in the environment variables.');
            return;
        }

        // Check if the script already exists
        if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaId}"]`)) {
            // Dynamically add the gtag.js script
            const script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            script.async = true;
            document.head.appendChild(script);

            // Initialize GA once the script loads
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                gtag('js', new Date());
                gtag('config', gaId);
            };
        }
    }, [])

    return (
        <div className="App">
            <HorizontalNav />
            <Banner/>

            <Suspense fallback={<div>Loading...</div>}>
                <LazyVerticals />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <LazyAboutUs/>
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <LazyChooseUs/>
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <BusinessModule />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <LazyServiceModule />
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                <LazyGlobalReach />
            </Suspense>

            {/*<Suspense fallback={<div>Loading...</div>}>*/}
            {/*    <LazyTestimonials />*/}
            {/*</Suspense>*/}

            <Suspense fallback={<div>Loading...</div>}>
                <LazyLhYug />
            </Suspense>

            <Footer />
            {/*<Footer/>*/}
        </div>
    );
}

export default App;
